<template>
    <div class="prepare container">
        <Loading :loadingHide="loadingHide"></Loading>
        <h2 v-if="lessonName">{{ `《${lessonName}》 ${type}` }}</h2>
        <ImageTextResource v-if="imageText.length" :imageText="imageText"></ImageTextResource>
        <VideoResource v-if="video.length" :video="video"></VideoResource>
        <AudioResource v-if="audio.length" :audio="audio"></AudioResource>
        <DocResource v-if="doc.length" :doc="doc"></DocResource>
        <ExercisesResource v-if="type == '作业'" :testId="testId" :classRecordId="classRecordId"></ExercisesResource>
    </div>
</template>
<script>
import ImageTextResource from '@/components/resource/imageTextResource';
import VideoResource from '@/components/resource/videoResource';
import AudioResource from '@/components/resource/audioResource';
import DocResource from '@/components/resource/docResource';
import ExercisesResource from '@/components/resource/exercisesResource';
import Loading from '@/components/loading';
import { mapGetters } from 'vuex';
export default {
    components: { ImageTextResource, VideoResource, AudioResource, DocResource, ExercisesResource, Loading },
    computed: {
        ...mapGetters(['prepareList'])
    },
    data() {
        return {
            classRecordId: "",
            testId: "",
            imageText: [],
            video: [],
            audio: [],
            doc: [],
            exercises: [],
            lessonName: '',
            type: '',
            loadingHide: false
        }
    },
    created() {
        console.log(this.$route)
        console.log(this.prepareList)
        if(!this.prepareList || !this.prepareList.length) {
            this.$router.push('/home');
            this.loadingHide = true;
        } else 
            this.getLessonResource();
            
    },
    mounted() {
        this.loadingHide = true;
    },
    methods: {
        getLessonResource() {
            if(this.$route.query && this.$route.query.name) {
                this.lessonName = this.$route.query.name;
            }
            if(this.$route.query && this.$route.query.id) {
                this.classRecordId = this.$route.query.id;
            }
            if(this.$route.query && this.$route.query.type) {
                this.type = this.$route.query.type == 'prepare'? '预习' : '作业';
            }
            if(this.prepareList) {
                this.prepareList.forEach(item => {
                    console.log(item)
                    if(item.type == "图文") {
                        this.imageText.push(item)
                    } else if(item.type == "视频") {
                        this.video.push(item)
                        console.log(this.video)
                    } else if(item.type == "音频") {
                        this.audio.push(item)
                    } else if(item.type == "文档" || item.type == "课件") {
                        this.doc.push(item)
                    } else if(item.type == "习题") {
                        this.exercises.push(item)
                        this.testId = item.id
                    }
                })
            }
        }
    },
}
</script>
<style scoped>
.prepare {
    padding: 15px 10px;
    background-color: #fff;
}
h2 {
    text-align: center;;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/resource.vue